<template>
  <CRow class="justify-content-center">
  <CCol>
    <CCard>
      <CCardHeader>
        <strong>Thông tin khách hàng</strong>
        <div class="card-header-actions">
          <CButton type="button" color="danger" shape="pill" class="mr-2" @click="resetPasswd">
            <CIcon name="cil-sync"/>
            Reset MK
          </CButton>
          <CButton type="button" color="info" shape="pill" class="mr-2" @click="save">
            <CIcon name="cil-save"/>
            Lưu
          </CButton>

          <CButton v-if="customerID" type="button" color="secondary" shape="pill" class="mr-2"
                   @click="refreshPage">
            <CIcon name="cil-sync"/>
            Tải lại
          </CButton>

          <CButton v-if="getAllowDeleteButton" type="button" color="danger" shape="pill" class="mr-2"
                   @click="doDelete"
          >
            <CIcon name="cil-trash"/>
            Xóa
          </CButton>

          <CButton type="button" color="secondary" shape="pill" class="mr-2"
                   @click="goBack"
          >
            <CIcon name="cil-chevron-left"/>
            Quay lại
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <CRow>
            <CCol sm="2">
              <CInput
                label="Tên khách hàng*:"
                type="text"
                v-model="customer.customer"
                placeholder="Tên khách hàng"
                required
              />
            </CCol>
            <CCol sm="4">
              <CInput
                label="Tên công ty*:"
                type="text"
                v-model="customer.company"
                placeholder="Tên công ty"
                required/>
            </CCol>
            <CCol sm="6">
              <CInput
                label="Địa chỉ công ty*:"
                placeholder="Địa chỉ công ty"
                type="text"
                v-model="customer.address"
                required/>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="2">
              <CInput
                label="Người giao nhận:"
                type="text"
                placeholder="Người giao nhận"
                v-model="customer.receiver"/>
            </CCol>
            <CCol sm="2">
              <CInput
                label="Chức vụ:"
                type="text"
                v-model="customer.role"
                placeholder="Chức vụ"/>
            </CCol>
            <CCol sm="2">
              <CInput
                label="Điện thoại:"
                type="text"
                placeholder="Điện thoại"
                v-model="customer.phone"/>
            </CCol>
            <CCol sm="2">
              <CInput
                label="Quyền:"
                type="text"
                placeholder="Quyền"
                v-model.number="customer.flag"/>
            </CCol>
            <CCol sm="4">
              <CTextarea
                label="Email:"
                type="text"
                placeholder="Email"
                v-model="customer.email"/>
            </CCol>
          </CRow>

          <CRow>
            <CCol md="3" class="text-right mt-1 p-0">
              Tệp mẫu đặt hàng:
            </CCol>
            <CCol>
              <CSpinner
                v-if="isUploading"
                color="info"
                class="mr-5 mt-0"
                style="width:1.2rem;height:1.2rem;"
              />

              <CIcon name="cil-paperclip" size="lg" class="mr-2"/>
              <label
                style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                class="mr-1"
                for="fileInput"
              >{{ fileName }}
              </label>
              <input type="file"
                     id="fileInput"
                     style="display: none;"
                     @change="onFileChange">

              <CButton v-if="selectedFile" shape="pill" color="info"
                       class="mr-2"
                       @click="handleUpload"
                       :disabled="isUploading"
              >
                <CIcon name="cil-cloud-upload"/>
                {{ isUploading ? "Đang tải..." : "Tải lên" }}
              </CButton>

              <CButton v-if="gotInfo && customer.sample" shape="pill" color="info"
                       class="mr-2"
                       @click="downloadFile(customer.sample)"
              ><CIcon name="cil-cloud-download" class="mr-1"/>Tải xuống</CButton>
            </CCol>
          </CRow>
      </CForm>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardHeader>
        <strong>Danh sách sản phẩm dành cho khách hàng</strong>
      </CCardHeader>
      <CCardBody class="pt-0">
        <CDataTable
          :items="products"
          :fields="allTypeFields"
          :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
          :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
          :itemsPerPage="100"
          sorter
          pagination
        >
          <template #no-items-view>
            <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
              Danh sách trống!
            </div>
          </template>

          <template #selected="{item, index}">
            <td>
              <div class="action-column">
                <input type="checkbox"
                       v-model="item.selected"
                       class="checkbox mt-2"/>
              </div>
            </td>
          </template>

          <template #stt="{item, index}">
            <td>
              {{index+1}}
            </td>
          </template>

          <template #sku="{item, index}">
            <td>
              <div>
                <CTextarea type="text"
                       v-model="item.sku" rows="1"/>
              </div>
            </td>
          </template>

          <template #price="{item, index}">
            <td>
              <div>
              <input type="number"
                     min="0"
                     class="qty-input"
                     v-model.number="item.price"/>
              </div>
            </td>
          </template>

          <template #vat="{item, index}">
            <td>
              <div>
                <input type="number"
                       min="0"
                       class="qty-input2"
                       v-model.number="item.vat"/>
              </div>
            </td>
          </template>

        </CDataTable>
      </CCardBody>
    </CCard>

  </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    return {
      allowDelete: true,
      customerID: '',
      customer: {
        id: 0,
        customer: '',
        company: '',
        address: '',
        receiver: '',
        role: '',
        phone: '',
        email: '',
        sample: '',
      },
      allTypeFields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'selected', label: 'Cho phép'},
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'sku', label: 'Tên quy ước', _style: 'min-width: 150px;'},
        { key: 'price', label: 'Giá bán (vnđ)'},
        { key: 'vat', label: 'VAT (%)'},
        { key: 'description', label: 'Mô tả' },
        { key: 'note', label: 'Ghi chú' },
      ],
      products: [],
      productsAllowed: [],
      fileName: 'Chọn tệp mẫu đặt hàng', // for purge BOM file upload
      selectedFile: null,
      isUploading: false,
      progress: null,
      gotInfo: false,
    };
  },
  created() {
    // console.log(this.$route)
    this.customerID = this.$route.query.id
    if(this.customerID) {
      this.refreshPage()
    }
  },
  computed: {
    getAllowDeleteButton() {
      return (this.allowDelete && this.customerID)
    }
  },
  methods: {
    mapProductsWithSelection(products, productsAllowed) {
      if (productsAllowed) {
        return products.map((item, index) => {
          const allowed = productsAllowed.find(pa => pa.product === item.product);

          return {
            stt: index + 1,
            selected: !!allowed,
            sku: allowed?.sku || '',
            price: allowed?.price ?? 0,
            vat: allowed?.vat ?? 0,
            product: item.product,
            description: item.description,
            note: item.note
          };
        });
      }
      return products;
    },
    refreshPage() {
      // console.log('customerID', this.customerID)
      this.$request.get(`/api/device/customer/${this.customerID}`).
      then(res=>{
        console.log(res.data)
        this.customer=res.data.customer
        const productList=res.data.products
        this.productsAllowed=res.data.productsAllowed
        this.products = this.mapProductsWithSelection(productList, this.productsAllowed);

        if(this.customer.status === ''){
          this.customer.status= 'Chưa kiểm tra'
        }
        if(res.data.status === 'success'){
          if (this.customer.sample) {
            this.fileName = this.customer.sample
            this.gotInfo = true
          }
        }
      })
    },
    resetPasswd(){
      // console.log('Lưu customer: ', this.customer)
      this.$swal.fire({
        title: "Reset mật khẩu về mặc định?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/customer_reset`, this.customer).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Reset mật khẩu khách hàng",
                html: "Reset mật khẩu khách hàng thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Reset mật khẩu khách hàng",
                html: "Reset mật khẩu khách hàng " + this.customer.customer +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    save() {
      // console.log('Lưu customer: ', this.customer)
      this.$swal.fire({
        title: "Lưu thông tin khách hàng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/customer`,
            {
              basic: this.customer,
              products: this.products,
            }).
          then(res => {
            if(res.data.status === 'success') {
              this.customer = res.data.customer;
              this.$swal.fire({
                icon: "success",
                title: this.customerID ? "Cập nhật thông tin khách hàng" : "Tạo thông tin khách hàng mới",
                html: "Lưu thông tin khách hàng thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.customerID ? "Cập nhật thông tin khách hàng" : "Tạo thông tin khách hàng mới",
                html: "Tạo thông tin khách hàng " + this.customer.customer +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    doDelete() {
      // console.log("Delete customer name:", this.customer.customer);
      this.$swal.fire({
        title: "Xóa thông tin khách hàng?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/device/customer/${this.customer.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa thông tin khách hàng",
                html: "Xóa thông tin khách hàng: " + this.customer.customer + " thành công" ,
              });
              this.$router.go(-1);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa thông tin khách hàng",
                html: "Xóa thông tin khách hàng: " + this.customer.customer +
                  "<br> lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.fileName = this.selectedFile.name;
        // console.log('selected file name:', this.fileName)
      } else {
        // console.log('no file selected');
        this.fileName = 'Chọn tệp mẫu đặt hàng'
      }
    },
    handleUpload() {
      if (!this.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("id", this.customer.id)
      // Send file using Axios
      this.$request.post(`/api/device/cus_upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.status === 'success') {
          this.refreshPage()
          // console.log(res.data.status)
          this.$swal.fire({
            icon: "success",
            title: "Tải lên tệp",
            text: "Tệp: " + this.fileName + " đã tải lên thành công!",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + this.fileName + " lưu lỗi: "+ res.data.status,
          });
        }
        this.isUploading = false;
      })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Lưu tệp đính kèm",
            html: "Tệp: " + this.fileName + " lưu lỗi: " + error,
          });
          this.isUploading = false;
        });
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/device/cus_download/${fileName}?id=${this.customer.id}`,
        { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
  },
};
</script>

<style>
.checkbox {
  width: 20px;
  height: 20px;
  margin: 0;
}

.qty-input {
  width: 120px; /* Max width for 4 characters */
  text-align: center;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.qty-input2 {
  width: 60px; /* Max width for 4 characters */
  text-align: center;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.qty-input:focus {
  outline: none;
  border-color: #007bff;
}
</style>
